import styled from 'styled-components';
import { DialogContentText as MuiDialogContentText } from '@material-ui/core';

/**
 * DialogContent는 Dialog 안에 표시될 단락을 담고 있는 컨테이너입니다.
 *
 * @version 1.0.0
 * @author [chayeoi](https://github.com/chayeoi)
*/

const DialogContentText = styled(MuiDialogContentText)`
`;

/** @component */
export default DialogContentText;
